// Какво всяка складова страница взема от layout-а (Inventory.tsx): бутона за
// менюто на тесен екран, текущия склад и пазача за незапазени промени. Новите
// страници го четат оттук (`useInventoryShell`) вместо проповете
// onOpenMobileMenu/isNarrow/warehouseId, спуснати през всеки файл; заварените
// страници минават на него при всяка задача, която ги докосва.
import { createContext, useContext } from "react";

export type LeaveGuard = (proceed: () => void) => void;

export type InventoryShell = {
  // Менюто е скрито (drawer под 640px) → страницата показва бутон „☰"
  isMenuButtonVisible: boolean;
  openMenu: () => void;
  isNarrow: boolean;
  warehouseId: number | null;
  warehouseName: string | null;
  // Страница с незапазени промени регистрира пазач; менюто и стрелката
  // „назад" питат през него. null при демонтаж.
  registerLeaveGuard: (guard: LeaveGuard | null) => void;
  // Навигация през пазача (менюто, линкове между страници)
  navigateGuarded: (to: string, state?: unknown) => void;
};

const noop = () => {};

export const InventoryShellContext = createContext<InventoryShell>({
  isMenuButtonVisible: false,
  openMenu: noop,
  isNarrow: false,
  warehouseId: null,
  warehouseName: null,
  registerLeaveGuard: noop,
  navigateGuarded: noop,
});

export const useInventoryShell = () => useContext(InventoryShellContext);
